import React from 'react';
import Image from '../../../components/loggedout/common/Image';

import ImacIpad from "~images/oddbods/illustration.png";

const ImacSection = () => {
  return (
    <Image alt="image" src={ImacIpad} />
  )
}
export default ImacSection